import type { EmailContactPdt, EmailContactSummary } from "../../types";
import styled from "styled-components";
import { Typography } from "../atoms/Typography";
import { PdtIcon } from "../atoms/PdtIcon";
import {
  DataTable,
  DataListSimpleHeader,
  DataListBody,
  DataListRow,
  DataListBodyItem,
} from "../atoms/Table";

interface EmailContactSummaryListProps {
  emailContacts: EmailContactSummary[];
}

const flexRatio = [0.5, 0.5, 1, 1, 1];

const headerTitles = [
  "名前",
  "部署",
  "メールアドレス",
  "製品管理責任者",
  "通知連絡先",
];

const StyledMemberContractList = styled.ul`
  display: flex;
  align-items: center;
  gap: 6px;
`;

function MemberContractList({ pdts }: { pdts: EmailContactPdt[] }) {
  return (
    <StyledMemberContractList>
      {pdts.map((pdt) => (
        <li key={pdt.id}>
          <PdtIcon src={pdt.iconPath} size={40} alt={pdt.name} />
        </li>
      ))}
    </StyledMemberContractList>
  );
}

function EmailContactSummary({
  emailContact,
}: {
  emailContact: EmailContactSummary;
}) {
  return (
    <DataListRow flexRatio={flexRatio}>
      <DataListBodyItem>
        <Typography size={2}>{emailContact.name}</Typography>
      </DataListBodyItem>
      <DataListBodyItem>
        <Typography size={2}>{emailContact.department}</Typography>
      </DataListBodyItem>
      <DataListBodyItem>
        <Typography size={2}>{emailContact.emailAddress}</Typography>
      </DataListBodyItem>
      <DataListBodyItem>
        <MemberContractList pdts={emailContact.responsiblePersons} />
      </DataListBodyItem>
      <DataListBodyItem>
        <MemberContractList pdts={emailContact.notificationRecipients} />
      </DataListBodyItem>
    </DataListRow>
  );
}

export function EmailContactSummaryList({
  emailContacts,
}: EmailContactSummaryListProps) {
  const items = emailContacts.map((emailContact) => (
    <EmailContactSummary key={emailContact.id} emailContact={emailContact} />
  ));
  return (
    <DataTable>
      <DataListSimpleHeader titles={headerTitles} flexRatio={flexRatio} />
      <DataListBody rows={items} />
    </DataTable>
  );
}
